import { useEffect, useRef, useState } from 'react';
import { cn } from '../ui/utils';

export function FluidChartContainer({
  children,
  className,
  chartClassName,
  height = 'clamp(16rem, 52vw, 22rem)',
}) {
  const containerRef = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const node = containerRef.current;
    if (!node) {
      return undefined;
    }

    const updateWidth = () => {
      setWidth(Math.round(node.getBoundingClientRect().width));
    };

    updateWidth();

    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', updateWidth);

      return () => {
        window.removeEventListener('resize', updateWidth);
      };
    }

    const observer = new ResizeObserver(() => {
      updateWidth();
    });

    observer.observe(node);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div ref={containerRef} className={cn('w-full min-w-0', className)}>
      <div className={cn('w-full min-w-0', chartClassName)} style={{ height }}>
        {width > 0 ? children(width) : null}
      </div>
    </div>
  );
}
